import mergeClasses from '../../../../../utils/shallowMerge';
import Price from '../../../../molecules/price';
import defaultClasses from '../CartItem.module.scss';
import clsx from 'clsx';
import React from 'react';

const ProductPrice = ({
  onSale,
  fullPrice,
  discountPrice,
  placement,
  className,
  customClasses,
}) => {
  const styles = mergeClasses(defaultClasses, customClasses);

  return (
    <div className={clsx(styles.price, className)}>
      {fullPrice && fullPrice !== 0 && (
        <Price
          placement={placement ?? 'cart'}
          type="regular"
          onSale={!!discountPrice && discountPrice !== fullPrice}
          value={fullPrice}
          className={styles.regular}
        />
      )}
      {discountPrice && discountPrice !== fullPrice && (
        <Price
          placement={placement ?? 'cart'}
          onSale={onSale ?? false}
          value={discountPrice}
          type={onSale ? 'sale' : 'regular'}
          className={styles.sale}
        />
      )}
    </div>
  );
};

export default ProductPrice;
